import { Col, Row, Typography } from 'antd';
import useEgresado from "./../../../hooks/HookEgresado";
import ModalFormEditInfo from './FormEditInfo';

const PersonalInfo = () => {
    const { alumno} = useEgresado();
    return <>
        <Row style={{ marginTop: 40 }}>
            <Col span={24}>
                <Typography.Title level={4} style={{ marginBottom: 8, fontWeight: 'bold' }}>
                    🎓 {alumno?.nombre_completo}
                </Typography.Title>
            </Col>
            <Col span={24}>
                <Typography.Paragraph style={{ margin: 0 }}>
                    <strong>Resumen profesional: </strong> {alumno?.objetivo_profesional ?? 'No disponible'}
                </Typography.Paragraph>
            </Col>
        </Row>

        <Row style={{ marginTop: 16 }}>
            <Col xs={24} sm={12}>
                <Typography.Paragraph style={{ margin: 0 }}>
                    <strong>Correo personal: </strong> {alumno?.correo_personal ?? 'No disponible'}
                </Typography.Paragraph>
            </Col>
            <Col xs={24} sm={12}>
                <Typography.Paragraph style={{ margin: 0 }}>
                    <strong>Teléfono: </strong> {alumno?.telefono_personal ?? 'No disponible'}
                </Typography.Paragraph>
            </Col>
            <Col span={24}>
                <Typography.Paragraph style={{ margin: 0 }}>
                    <strong>Dirección: </strong>
                    {alumno?.colonia?.nombre_localidad + ', ' + alumno?.colonia?.municipio?.nombre_municipio +
                        ', ' + alumno?.colonia?.municipio?.estado?.nombre_estado + '. C.P. ' + alumno?.colonia?.codigo_postal ?? 'No disponible'}
                </Typography.Paragraph>
            </Col>
            <ModalFormEditInfo />
        </Row>
    </>
}
export default PersonalInfo;
